/**
 * @file Record (high temporal frequency, ie every frame) information about the current state of the experiment.
 * To be used in conjunction with eye tracking from a MatLab experiment to measure gaze position at specific points in time.
 */
import { displayOptions, eyeTrackingStimulusRecords, fixationConfig, showConditionNameConfig, status, thisExperimentInfo, viewingDistanceCm, } from "./global";
import { getCursorLocation } from "./utils";
/**
 * Get a record (object) about the current state of the experiment.
 * @param stimulus Target stimulus object, textStim
 * @param easyEyesFunction
 * @returns
 */
const getCurrentPositionsRecord = (stimulus = undefined, easyEyesFunction = "") => {
    let posixTimeSec, cursorPositionXYApplePx, crosshairPositionXYApplePx, targetPositionXYApplePx, experiment, blockNumber, block_condition, conditionName, pavloviaSessionId, trialNumber, pxPerCm, viewingDistanceCmNum, screenDimensions, nearPointX, nearPointY;
    if (typeof stimulus !== "undefined" && stimulus._autoDraw === true) {
        const [x, y] = stimulus._pos;
        targetPositionXYApplePx = getAppleCoordinatePosition(x, y).toString();
    }
    else {
        targetPositionXYApplePx = "";
    }
    const cursorPositionXYPsychoJSPx = getCursorLocation();
    cursorPositionXYApplePx = getAppleCoordinatePosition(cursorPositionXYPsychoJSPx[0], cursorPositionXYPsychoJSPx[1]).toString();
    crosshairPositionXYApplePx = getAppleCoordinatePosition(fixationConfig.pos[0], fixationConfig.pos[1]).toString();
    experiment = thisExperimentInfo.experiment;
    pavloviaSessionId = thisExperimentInfo.participant;
    thisExperimentInfo;
    blockNumber = status.block;
    block_condition = status.block_condition;
    conditionName = showConditionNameConfig.name;
    trialNumber = status.trial;
    posixTimeSec = Date.now() / 1000;
    pxPerCm = displayOptions.pixPerCm;
    viewingDistanceCmNum = viewingDistanceCm.current;
    screenDimensions = getScreenDimensions();
    nearPointX = displayOptions.nearPointXYPix[0];
    nearPointY = displayOptions.nearPointXYPix[1];
    const thisRecord = {
        experiment: experiment,
        pavloviaSessionId: pavloviaSessionId,
        posixTimeSec: posixTimeSec.toString(),
        cursorPositionXYPx: cursorPositionXYApplePx,
        crosshairPositionXYPx: crosshairPositionXYApplePx,
        targetPositionXYPx: targetPositionXYApplePx,
        blockNumber: blockNumber,
        block_condition: block_condition,
        conditionName: conditionName,
        trialNumber: trialNumber,
        easyEyesFunction: easyEyesFunction,
        pxPerCm: pxPerCm.toString(),
        viewingDistanceCm: viewingDistanceCmNum.toString(),
        screenWidthPx: screenDimensions[0],
        screenHeightPx: screenDimensions[1],
        nearpointXYPx: getAppleCoordinatePosition(nearPointX, nearPointY).toString(),
    };
    return thisRecord;
};
/**
 * Create a record at this point of time and add it to the array of previous records
 * @param stimulus Target stimulus object, textStim
 * @param easyEyesFunction
 */
export const recordStimulusPositionsForEyetracking = (stimulus, easyEyesFunction = "") => {
    const thisRecord = getCurrentPositionsRecord(stimulus, easyEyesFunction);
    eyeTrackingStimulusRecords.push(thisRecord);
};
/**
 * Convert from psychojs units (origin at center of screen, increasing up and to the right) to Apple units (origin at top left corner, increasing down and to the right)
 * @param x in px
 * @param y in px
 * @returns [x,y] in px
 */
export const getAppleCoordinatePosition = (x, y) => {
    const screenDimensions = getScreenDimensions();
    const windowWidth = screenDimensions[0];
    const windowHeight = screenDimensions[1];
    const appleX = Math.floor(x + windowWidth / 2);
    const appleY = Math.floor(-y + windowHeight / 2);
    return [appleX, appleY];
};
export const getPsychoJSCoordinatePositionFromAppleCoordinatePosition = (x, y) => {
    const screenDimensions = getScreenDimensions();
    const windowWidth = screenDimensions[0];
    const windowHeight = screenDimensions[1];
    const psychoJSX = x - windowWidth / 2;
    const psychoJSY = windowHeight / 2 - y;
    return [psychoJSX, psychoJSY];
};
/**
 * Get the width,height of the screen, defaulting to psychoJS' values and falling back on window inner dimensions
 * @returns [widthPx, heightPx]
 */
export const getScreenDimensions = () => {
    if (displayOptions && displayOptions.window) {
        const win = displayOptions.window;
        return win._size;
    }
    else {
        return [window.innerWidth, window.innerHeight];
    }
};
